module.exports = __webpack_public_path__ + "client/img/invest_04.5f8becf0.png";